export const PLANNING_UPDATES_RESULTS_SCROLL_KEY = 'cityscope:planning-updates:results-scroll';
export const PLANNING_UPDATES_RESULTS_SCROLL_VALUE = 'results';

export const requestPlanningUpdatesResultsScroll = () => {
  if (typeof window === 'undefined') return;

  try {
    window.sessionStorage.setItem(
      PLANNING_UPDATES_RESULTS_SCROLL_KEY,
      PLANNING_UPDATES_RESULTS_SCROLL_VALUE
    );
  } catch (_error) {
    // Non-essential: routing should still work if storage is unavailable.
  }
};
